import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import CommonAppointmentCalendar from "./CommonAppointmentCalendar";
import { fetchAppointmentsLeadAction } from "../../../store/actions/AppointmentActions";

const TelecallerAppointmentCalendar = ({
  leadId,
  doctorId,
  patientId,
}) => {
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState(null);

  const { appointments = [] } = useSelector(
    (state) => state.appointmentState || {}
  );

  useEffect(() => {
    if (leadId) {
      dispatch(fetchAppointmentsLeadAction(leadId, patientId));
    }
  }, [leadId, patientId, dispatch]);

  // Check if appointment already exists
  const hasAppointment = appointments.some(
    (a) => String(a.lead_id) === String(leadId)
  );

  return (
    <div>

      {/* Calendar */}
      <CommonAppointmentCalendar
        leadId={leadId}
        patientId={patientId}
        doctorId={doctorId}
        module="telecaller"
        appointmentType="telecaller"
        currentLeadId={leadId}
        selectedDate={selectedDate}
        openFromTelecaller
      />

      {/* Booking UI */}
      {!hasAppointment && (
        <div
          className="card border-0 shadow-sm shadow-none mt-3"
          style={{
            borderRadius: "14px",
          }}
        >

          <div className="card-body card shadow-none">

            <div className="row align-items-end g-3">

              {/* Date Picker */}
              <div className="col-12 col-md-4 col-lg-3">

                <label
                  className="form-label fw-semibold mb-2"
                  style={{
                    fontSize: "15px",
                    color: "#343a40",
                  }}
                >
                  Select Preferred Date
                </label>

                <div
                  className="position-relative"
                  style={{
                    maxWidth: "260px",
                    width: "100%",
                  }}
                >

                  {/* Calendar Icon */}
                  <i
                    className="fa fa-calendar position-absolute"
                    style={{
                      left: "14px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      fontSize: "16px",
                      color: "#6c757d",
                      zIndex: 10,
                      pointerEvents: "none",
                    }}
                  />

                  <DatePicker
                    selected={selectedDate}
                    onChange={(date) => setSelectedDate(date)}
                    minDate={new Date()}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="DD/MM/YYYY"
                    showPopperArrow={false}
                    popperPlacement="bottom-start"
                    className="form-control telecaller-date-input"
                    wrapperClassName="w-100"
                  />

                  {/* Clear Icon */}
                  {selectedDate && (
                    <i
                      className="fa fa-times-circle position-absolute"
                      onClick={() => setSelectedDate(null)}
                      style={{
                        right: "14px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        fontSize: "18px",
                       
                        cursor: "pointer",
                        zIndex: 10,
                      }}
                    />
                  )}

                </div>
              </div>

              {/* Confirm Button */}
              <div className="col-12 col-md-2 col-lg-2">

                <button
                  className="btn btn-primary w-100 d-flex align-items-center justify-content-center"
                  style={{
                    height: "50px",
                    borderRadius: "10px",
                    fontWeight: "600",
                    fontSize: "15px",
                    whiteSpace: "nowrap",
                    minWidth: "120px",
                  }}
                  onClick={() => {
                    if (!selectedDate) {
                      alert("Please select a date");
                      return;
                    }

                    window.dispatchEvent(
                      new CustomEvent("telecallerBookClick", {
                        detail: { selectedDate },
                      })
                    );
                  }}
                >
                  Confirm
                </button>

              </div>

            </div>

          </div>

          {/* Custom Styling */}
          <style>
            {`
              .react-datepicker-wrapper {
                width: 100%;
              }

              .telecaller-date-input {
                width: 100% !important;
                height: 50px !important;
                border-radius: 10px !important;
                border: 1px solid #ced4da !important;
                padding-left: 42px !important;
                padding-right: 42px !important;
                font-size: 15px !important;
                transition: all 0.2s ease;
              }

              .telecaller-date-input:focus {
                border-color: #0d6efd !important;
                box-shadow: 0 0 0 0.15rem rgba(13,110,253,.15) !important;
                outline: none !important;
              }

              @media (max-width: 768px) {

                .telecaller-date-input {
                  height: 46px !important;
                  font-size: 14px !important;
                }

                .btn {
                  height: 46px !important;
                  font-size: 14px !important;
                }

                .position-relative {
                  max-width: 100% !important;
                }
              }
            `}
          </style>

        </div>
      )}
    </div>
  );
};

export default TelecallerAppointmentCalendar;